import { motion, AnimatePresence } from 'framer-motion';
import { Bot } from 'lucide-react';

export type ChatMessageType = 'greeting' | 'swipe-right' | 'swipe-left' | 'help-offer';

export interface ChatMessage {
  id: string;
  text: string;
  type: ChatMessageType;
}

interface AIChatBubbleProps {
  message: ChatMessage | null;
}

export function AIChatBubble({ message }: AIChatBubbleProps) {
  return (
    <AnimatePresence mode="wait">
      {message && (
        <motion.div
          key={message.id}
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -10, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="flex items-start gap-3 max-w-md mx-auto"
        >
          <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-full flex items-center justify-center shadow-lg">
            <Bot className="w-5 h-5 text-white" />
          </div>
          <div className="flex-1 bg-gray-100 rounded-2xl rounded-tl-sm px-5 py-3.5 shadow-md border border-gray-200">
            <p className="text-gray-800 text-sm leading-relaxed font-medium">
              {message.text}
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export const chatMessages = {
  greeting: [
    "Here's another great match for your skills.",
    "This role fits your goals perfectly.",
    "Found a curated opportunity just for you.",
  ],
  swipeRight: [
    "Application sent ✔️ I'll track everything for you.",
    "Applied successfully! I'll handle the follow-up.",
    "Great choice! I've got this tracked.",
  ],
  swipeLeft: [
    "No problem — I'll find better matches.",
    "Skipped. Let's keep looking together.",
    "Got it. More opportunities coming your way.",
  ],
  helpOffer: [
    "Want resume help before you apply?",
    "Need interview prep? I'm here to help.",
    "I can boost your profile visibility.",
    "Ready to level up? Let's chat.",
  ],
};

export function getRandomMessage(type: ChatMessageType): string {
  const messages = chatMessages[type === 'greeting' ? 'greeting' : type === 'swipe-right' ? 'swipeRight' : type === 'swipe-left' ? 'swipeLeft' : 'helpOffer'];
  return messages[Math.floor(Math.random() * messages.length)];
}
